import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import { GetSubBookingCode, UpdateBranch } from "../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  GetCompany,
  GetBookingCode,
  GetUser,
  GetCompanyLogin,
  PostCompanyLogin,
  UpdateCompanyLogin,
  VerifyLoginId,
  GetLinkBookingCode,
} from "../../Service/_index";
import Button from "@mui/material/Button";
import Styles from "../../UiComponents/Scss/AddPopup.module.scss";

const CreateCompanyLogin = (props) => {
  const {
    setCreateCompanyLoginDrawer,
    GetActiveCompanyLoginData,
    formType,
    selectedData,
    title,
  } = props;
  let formRef = useRef();

  const initialValues = {
    companyId: "",
    bookingCodeId: "",
    url: "",
    userId: "",
    userIdNumber: "",
    password: "",
    branch: "",
    remarks: "",
    subBookingCodeId: "",
  };

  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [companyLoginDetails, setCompanyLoginDetails] = useState([]);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [loginIdErrMsg, setLoginIdErrMsg] = useState("");
  const [isButtonDisable, setIsButtonDisabel] = useState(false);

  const [companyValue, setCompanyValue] = useState(
    formType === "edit" ? selectedData?.companyId?.shortName : null
  );
  const [bookingCodeValue, setBookingCodeValue] = useState(
    formType === "edit" ? selectedData?.bookingCodeId?.bookingCode : null
  );
  const [userValue, setUserValue] = useState(
    formType === "edit" ? selectedData.userId.name : null
  );
  const [subBookingCodeValue, setSubBookingCodeValue] = useState(
    formType === "edit" ? selectedData?.subBookingCodeId?.subBookingCode : null
  );
  const [selectedCompanyId, setSelectedCompanyId] = useState();

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };
  const GetLinkBookingCodeDetails = () => {
    GetLinkBookingCode().then((res) => {
      console.log(res?.data);
      console.log(selectedCompanyId);
      const modifiedBookingCodeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCodeId.bookingCode,
              value: e.bookingCodeId._id,
            };
          }
        })
        .filter(Boolean);
      console.log(selectedCompanyId);
      const modData = modifiedBookingCodeDetails.filter(
        (e) => e?.companyId?._id === selectedCompanyId
      );
      console.log("SelectedCompany:", selectedCompanyId);
      console.log("modData:", modData);
      let uniqueObjectsMap = new Map();
      modData.map((obj) => {
        uniqueObjectsMap.set(obj.bookingCodeId._id, obj);
      });
      let uniqueArray = Array.from(uniqueObjectsMap.values());
      console.log(uniqueArray);
      setBookingCodeDetails(uniqueArray);
    });
  };

  // const GetBookingCodeDetails = () => {
  //   GetBookingCode({ isAscending: true }).then((res) => {
  //     const modifiedBookingCodeDetails = res.data
  //       .map((e) => {
  //         if (e.isEnabled) {
  //           return {
  //             ...e,
  //             label: e.bookingCode,
  //             value: e._id,
  //           };
  //         } else {
  //           return null;
  //         }
  //       })
  //       .filter(Boolean);
  //     setBookingCodeDetails(modifiedBookingCodeDetails);
  //   });
  // };

  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCodeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      const FilterSubBookingCodeDetails = modifiedSubBookingCodeDetails.filter(
        (item) => item.bookingCode === bookingCodeValue
      );
      setSubBookingCodeDetails(FilterSubBookingCodeDetails);
    });
  };

  const GetUserDetails = () => {
    GetUser({ isAscending: true })
      .then((res) => {
        const modifiedUserDetails = res.data
          .map((e) => {
            if (e.userType.includes("user")) {
              return {
                ...e,
                label: e?.name,
                value: e?._id,
              };
            } else {
              return null;
            }
          })
          .filter(Boolean);
        const ExtraLabel = [
          { name: "All", _id: "All", label: "All" },
          { name: "Admin", _id: "Admin", label: "Admin" },
        ];
        setUserDetails([...ExtraLabel, ...modifiedUserDetails]);
      })
      .catch((err) => ToastError("Network Error"));
  };

  const GetCompanyLoginDetails = () => {
    GetCompanyLogin().then((res) => {
      setCompanyLoginDetails(res.data);
    });
  };
  const [urlValue, setUrlvalue] = React.useState(null);

  useEffect(() => {
    // GetSubBookingCodeDetails();
    GetCompanyDetails();
    // GetBookingCodeDetails();

    GetUserDetails();
    GetCompanyLoginDetails();
    if (formType === "edit") {
      formRef.setFieldValue("companyId", selectedData?.companyId?._id);
      formRef.setFieldValue("bookingCodeId", selectedData.bookingCodeId?._id);
      formRef.setFieldValue(
        "subBookingCodeId",
        selectedData.subBookingCodeId?._id
      );
      formRef.setFieldValue("url", selectedData?.url);
      formRef.setFieldValue("userId", selectedData?.userId?._id);
      formRef.setFieldValue(
        "userIdNumber",
        selectedData?.userIdNumber.replace(/'/g, "") || "" // Changes by Arun, Remove single quote in login id
      );
      formRef.setFieldValue("password", selectedData?.password);
      formRef.setFieldValue("branch", selectedData?.branch);
      formRef.setFieldValue("remarks", selectedData?.remarks);
      setUrlvalue(selectedData?.url);
    }
  }, []);

  useEffect(() => GetLinkBookingCodeDetails(), [selectedCompanyId]);
  useEffect(() => GetSubBookingCodeDetails(), [bookingCodeValue]);

  const [UrlCollection, setUrlCollection] = useState([]);
  const AutoUrlShow = (value) => {
    const showUrlData = companyLoginDetails.filter(
      (e) => e?.companyId?._id === value?._id
    );
    const uniqueLabels = [...new Set(showUrlData.map((e) => e.url))];
    setUrlCollection(uniqueLabels);
    if (!uniqueLabels.length) {
      setUrlvalue(null);
      formRef.setFieldValue("url", "");
    } else {
      setUrlvalue(uniqueLabels[0]);
      formRef.setFieldValue("url", uniqueLabels[0]);
    }
  };

  const onSubmit = (data, type) => {
    if (
      data?.companyId &&
      data?.bookingCodeId &&
      data?.url &&
      data?.userIdNumber &&
      data?.password &&
      data?.remarks &&
      data?.branch &&
      data?.subBookingCodeId
      // &&
      // data?.userId
    ) {
      let SubmitType =
        formType === "edit"
          ? UpdateCompanyLogin(selectedData._id, data)
          : PostCompanyLogin(data);
      SubmitType.then((res) => {
        if (res) {
          GetActiveCompanyLoginData();
          if (!type) {
            setCreateCompanyLoginDrawer(false);
          }
        }
      });
    } else {
      ToastError("Fill all the fields");
    }
  };

  const VerifyLoginIdFunction = (e, values) => {
    if (!values.companyId.length) {
      // ToastError("Please select company");
      formRef.setFieldValue("userIdNumber", "");
    } else {
      const bodyData = {
        companyId: values.companyId,
        userIdNumber: e,
      };
      VerifyLoginId(bodyData).then((res) => {
        if (res?.response?.status === 500) {
          setIsButtonDisabel(true);
          setLoginIdErrMsg(res.response.data.message);
        } else {
          setIsButtonDisabel(false);
          setLoginIdErrMsg("");
        }
      });
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="DrawerContainer">
        <Grid container className="DrawerHeader">
          <Grid item xs={6} sm={6}>
            <Typography>{title} Company Login</Typography>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => setCreateCompanyLoginDrawer(false)}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
        </Grid>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          innerRef={(ref) => {
            if (ref) {
              formRef = ref;
            }
          }}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className={Styles.addContent}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="Select Company"
                        value={values.companyId}
                        important="*"
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Company
                    </Typography>
                    <Autocomplete
                      name="companyId"
                      options={companyDetails}
                      value={companyValue}
                      onChange={(e, v) => {
                        setSelectedCompanyId(v?._id);
                        console.log("V:", v);
                        setFieldValue("companyId", v?._id);
                        setCompanyValue(v?.label);

                        AutoUrlShow(v);
                      }}
                      className="AutoComplete_InputBox w-100"
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Company" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value
                      }
                      renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                          {option.shortName}
                        </li>
                      )}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  {/* {UrlCollection.length ? (
                      <Grid item xs={12} sm={6}>
                        <FloatLabel
                          label="Select URL"
                          value={values.url}
                          important="*"
                        >
                          <Select
                            className="AutoComplete_InputBox w-100"
                            id="demo-simple-select"
                            value={values?.url}
                            onChange={(e, v) =>
                              setFieldValue("url", v.props.value)
                            }
                          >
                            {UrlCollection?.map((url, index) => (
                              <MenuItem key={index} value={url}>
                                {url}
                              </MenuItem>
                            ))}
                          </Select>
                        </FloatLabel>
                      </Grid>
                    ) : ( */}
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="Branch"
                        value={values.branch}
                        important="*"
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Branch
                    </Typography>
                    <Field
                      name="branch"
                      className="InputFiled"
                      placeholder="Select Branch"
                    style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  {/* )} */}
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="Select BookingCode"
                        value={values.bookingCodeId}
                        important="*"
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Booking Code
                    </Typography>
                    <Autocomplete
                      name="bookingCodeId"
                      className="AutoComplete_InputBox"
                      options={bookingCodeDetails}
                      value={bookingCodeValue}
                      onChange={(e, v) => {
                        console.log("V", v);
                        setFieldValue(
                          "bookingCodeId",
                          v?.bookingCodeId._id
                        );
                        setBookingCodeValue(v?.label);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select BookingCode" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value
                      }
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    {/* <FloatLabel
                        label="Select SubBooking Code"
                        value={values.subBookingCodeId}
                        important="*"
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      SubBooking Code
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      disablePortal
                      id="combo-box-demo"
                      name="subBookingCodeId"
                      value={subBookingCodeValue}
                      options={subBookingCodeDetails}
                      onChange={(e, v) => {
                        setFieldValue("subBookingCodeId", v?._id);
                        setSubBookingCodeValue(v?.label);
                      }}
                      // renderInput={(params) => <TextField {...params} />}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select SubBooking Code" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.subBookingCode === value
                      }
                    />
                    {/* </FloatLabel> */}
                  </Grid>



                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="User Name"
                        value={values.userId || userValue}
                        important="*"
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      User Name
                    </Typography>
                    <Autocomplete
                      name="userId"
                      options={userDetails}
                      value={userValue}
                      onInputChange={(e, v) => setUserValue(v)}
                      onChange={(e, v) => {
                        setFieldValue("userId", v?._id);
                        setUserValue(v?.label);
                      }}
                      className="AutoComplete_InputBox w-100"
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select UserName" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.name === value
                      }
                      renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                          {option.name}
                        </li>
                      )}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="Login Id"
                        value={values.userIdNumber}
                        important="*"
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Login Id
                    </Typography>
                    <Field
                      name="userIdNumber"
                      className="InputFiled"
                      placeholder="Enter LoginId"
                      onBlur={(e) =>
                        VerifyLoginIdFunction(e.target.value, values)
                      }
                      onKeyDown={handleKeyDown}
                      style={{ textTransform: "uppercase", }}
                    />
                    {/* </FloatLabel> */}
                    <div className="errorMessage ">
                      <div>{loginIdErrMsg}</div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="Password"
                        value={values.password}
                        important="*"
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Password
                    </Typography>
                    <Field
                      name="password"
                      className="InputFiled"
                      placeholder="Enter Password"
                      onKeyDown={handleKeyDown}
                      style={{ textTransform: "uppercase", }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      URL
                    </Typography>
                    {/* <FloatLabel label="URL" value={values.url} important="*"> */}
                    <Field name="url" className="InputFiled" placeholder="Enter URL" style={{ textTransform: "uppercase", }} />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    {/* <FloatLabel
                        label="Remarks"
                        value={values.remarks}
                        style={{ textTransform: "uppercase" }}
                        important="*"
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Remarks
                    </Typography>
                    <div className="common-field-wrapper">
                      <Field
                        name="remarks"
                        className="InputFileds"
                        placeholder={formType !== "view" && formType !== "edit" ? "Write here..." : ""}
                      // style={{ height: "90px", minHeight: "90px" }}
                      style={{ textTransform: "uppercase" }}
                      />
                    </div>
                    {/* </FloatLabel> */}
                  </Grid>
                </Grid>
              </div>
              <div className="Dialog_Footers">
                <div className="Dialog_Button_Groups">
                  <Button
                    onClick={() => setCreateCompanyLoginDrawer(false)}
                    className="Dialog_Cancels"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="Dialog_Saves"
                    disabled={isButtonDisable}
                  >
                    {title}
                  </Button>
                </div>
                <Button
                  disabled={isButtonDisable}
                  sx={{ display: formType === "add" ? "block" : "none", marginLeft: "10px", }}
                  className="Dialog_Save_Exits"
                  onClick={() => {
                    onSubmit(values, "save&create");
                    setCreateCompanyLoginDrawer(true);
                    setFieldValue("userIdNumber", "");
                    setFieldValue("password", "");
                  }}
                // type="submit"
                >
                  Save & Create New
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default CreateCompanyLogin;
